module.exports = __webpack_public_path__ + "img/bg_apartment.6a7e0bbf.jpg";